import { CheckboxOption } from '@uc/web/shared/data-models';
import {
	EventsFilterOptions,
	EventsFilterPill,
	EventsMultiOptionQueryParam,
	EventsSearchPayload,
} from '../models/open-days.models';

export const generatePills = (
	payload: EventsSearchPayload,
	filters: EventsFilterOptions,
): EventsFilterPill[] => {
	return [
		...generateFilterPill(payload.locationIds, filters.locations, 'loc'),
		...generateFilterPill(payload.typeIds, filters.types, 'type'),
		...generateDatePill(payload.dateFrom, payload.dateTo),
	];
};

const generateFilterPill = (
	selectedFilterIds: number[] | null,
	filters: CheckboxOption[],
	urlKey: EventsMultiOptionQueryParam,
): EventsFilterPill[] => {
	const selectedFilters = filters.filter((filter) =>
		selectedFilterIds?.includes(filter.id),
	);
	return selectedFilters.map((filter) => {
		const label = filter.name ? filter.name : '';
		return {
			label,
			urlKey,
			urlValue: filter.url_name,
		};
	});
};

const generateDatePill = (
	fromDate: string | null,
	toDate: string | null,
): EventsFilterPill[] => {
	if (!fromDate) return [];
	const date = toDate ? `${fromDate} - ${toDate}` : fromDate;
	return [
		{
			label: date,
			urlKey: 'date',
			urlValue: date,
		},
	];
};
